/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RouteHubStopoverTriggerEnum =
  (typeof RouteHubStopoverTriggerEnum)[keyof typeof RouteHubStopoverTriggerEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RouteHubStopoverTriggerEnum = {
  LateArrival: 0,
  AvoidsTransitHome: 1,
} as const;
